// Define the interface for the request object with possible nested structure
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "nocoExecute", {
    enumerable: true,
    get: function() {
        return nocoExecute;
    }
});
const _common = require("@nestjs/common");
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const logger = new _common.Logger('nocoExecute');
// Helper function to flatten a nested array recursively
const flattenArray = (res)=>{
    return Array.isArray(res) ? res.flatMap((r)=>flattenArray(r)) : res;
};
/**
 * Execute the request object
 * @param requestObj request object
 * @param resolverObj resolver object which may contain resolver functions or data
 * @param dataTree data tree that holds the state of the resolved data
 * @param rootArgs root arguments passed for nested processing
 * @returns Promise<any> returns the resolved data
 **/ const nocoExecute = async (requestObj, resolverObj, dataTree = {}, rootArgs = null)=>{
    // Handle array of resolvers by executing nocoExecute on each sequentially
    if (Array.isArray(resolverObj)) {
        const res = [];
        for(let i = 0; i < resolverObj.length; i++){
            const resolver = resolverObj[i];
            dataTree[i] = dataTree[i] || {};
            res.push(await nocoExecuteSingle(requestObj, resolver, dataTree[i], rootArgs));
        }
        return res;
    } else {
        return nocoExecuteSingle(requestObj, resolverObj, dataTree, rootArgs);
    }
};
const nocoExecuteSingle = async (requestObj, resolverObj, dataTree = {}, rootArgs = null)=>{
    const res = {};
    /**
   * Recursively extract nested data from the dataTree and resolve it.
   * @param path the path of keys to traverse in the data tree
   * @param dataTreeObj the current data tree object
   * @param resolver the resolver object to call functions or return values
   * @param args arguments passed to resolver functions
   * @returns Promise resolving the nested value
   */ const extractNested = async (path, dataTreeObj, resolver = {}, args = {})=>{
        if (path.length) {
            const key = path[0];
            // If key doesn't exist in dataTree, resolve using resolver or create a placeholder
            if (dataTreeObj[key] === undefined || dataTreeObj[key] === null) {
                var _dataTreeObj___proto_____columnAliases, _dataTreeObj___proto__;
                if (typeof resolver[key] === 'function') {
                    dataTreeObj[path[0]] = resolver[key](args); // Call resolver function
                } else if (typeof resolver[key] === 'object') {
                    dataTreeObj[path[0]] = Promise.resolve(resolver[key]); // Resolve object directly
                } else if (dataTreeObj == null ? void 0 : (_dataTreeObj___proto__ = dataTreeObj.__proto__) == null ? void 0 : (_dataTreeObj___proto_____columnAliases = _dataTreeObj___proto__.__columnAliases) == null ? void 0 : _dataTreeObj___proto_____columnAliases[path[0]]) {
                    var _dataTreeObj___proto_____columnAliases_path_, _dataTreeObj___proto_____columnAliases1, _dataTreeObj___proto__1;
                    // Handle column alias lookup
                    dataTreeObj[path[0]] = extractNested(dataTreeObj == null ? void 0 : (_dataTreeObj___proto__1 = dataTreeObj.__proto__) == null ? void 0 : (_dataTreeObj___proto_____columnAliases1 = _dataTreeObj___proto__1.__columnAliases) == null ? void 0 : (_dataTreeObj___proto_____columnAliases_path_ = _dataTreeObj___proto_____columnAliases1[path[0]]) == null ? void 0 : _dataTreeObj___proto_____columnAliases_path_.path, dataTreeObj, {}, args);
                } else {
                    if (typeof dataTreeObj === 'object') {
                        dataTreeObj[path[0]] = Promise.resolve(resolver[key]);
                    }
                }
            } else if (typeof dataTreeObj[key] === 'function') {
                // If the key is a function, invoke it with args
                dataTreeObj.__proto__ = _extends({}, dataTreeObj.__proto__, {
                    [key]: dataTreeObj[key](args)
                });
            }
            // Recursively handle nested arrays or resolve promises
            const res1 = await (dataTreeObj[path[0]] instanceof Promise ? dataTreeObj[path[0]] : Promise.resolve(dataTreeObj[path[0]]));
            if (Array.isArray(res1)) {
                const res = [];
                for(let i = 0; i < res1.length; i++){
                    res.push(await extractNested(path.slice(1), res1[i], {}, args));
                }
                return res;
            } else {
                return res1 !== null && res1 !== undefined ? await extractNested(path.slice(1), res1, {}, args) : null;
            }
        } else {
            return dataTreeObj; // If path is exhausted, return data tree object
        }
    };
    /**
   * Extract the value for the given key from the resolver object or data tree.
   * If the key is a function, call it with args, otherwise resolve the value.
   * @param key the key to extract
   * @param args the arguments for nested extractions
   */ function extractField(key, args) {
        var _resolverObj___proto_____columnAliases, _resolverObj___proto__;
        // Check if the key is a column alias or needs to be resolved
        if (!(resolverObj == null ? void 0 : (_resolverObj___proto__ = resolverObj.__proto__) == null ? void 0 : (_resolverObj___proto_____columnAliases = _resolverObj___proto__.__columnAliases) == null ? void 0 : _resolverObj___proto_____columnAliases[key])) {
            if (resolverObj) {
                // Resolve if it's a function, object, or value
                if (typeof resolverObj[key] === 'function') {
                    res[key] = resolverObj[key](args); // Call function
                } else if (typeof resolverObj[key] === 'object') {
                    res[key] = Promise.resolve(resolverObj[key]); // Resolve object
                } else {
                    try {
                        res[key] = Promise.resolve(resolverObj[key]); // Resolve value
                    } catch (e) {
                        logger.error(e);
                    }
                }
            }
            dataTree[key] = res[key]; // Store result in dataTree
        } else {
            // If nested, extract the nested value using extractNested function
            res[key] = (async ()=>{
                var _resolverObj___proto_____columnAliases_key, _resolverObj___proto_____columnAliases, _resolverObj___proto__, _args_nested;
                const res1 = await extractNested(resolverObj == null ? void 0 : (_resolverObj___proto__ = resolverObj.__proto__) == null ? void 0 : (_resolverObj___proto_____columnAliases = _resolverObj___proto__.__columnAliases) == null ? void 0 : (_resolverObj___proto_____columnAliases_key = _resolverObj___proto_____columnAliases[key]) == null ? void 0 : _resolverObj___proto_____columnAliases_key.path, {}, resolverObj, args == null ? void 0 : (_args_nested = args.nested) == null ? void 0 : _args_nested[key]);
                // Flatten the array if it's nested
                return Array.isArray(res1) ? flattenArray(res1) : res1;
            })();
        }
    }
    // Determine which keys to extract from the request object or resolver object
    const extractKeys = requestObj && typeof requestObj === 'object' ? Object.keys(requestObj).filter((k)=>requestObj[k]) : Object.keys(resolverObj);
    const out = {}; // Holds the final output
    for (const key of extractKeys){
        var _rootArgs_nested;
        // Extract the field for each key
        extractField(key, rootArgs == null ? void 0 : (_rootArgs_nested = rootArgs.nested) == null ? void 0 : _rootArgs_nested[key]);
        // Handle nested request objects by recursively calling nocoExecute
        if (requestObj[key] && typeof requestObj[key] === 'object') {
            if (res[key]) {
                const res1 = await res[key];
                if (Array.isArray(res1)) {
                    // Handle arrays of results by executing nocoExecute on each element sequentially
                    dataTree[key] = dataTree[key] || [];
                    res[key] = [];
                    for(let i = 0; i < res1.length; i++){
                        var _rootArgs_nested1;
                        const r = res1[i];
                        dataTree[key][i] = dataTree[key][i] || {};
                        res[key].push(dataTree[key][i] = await nocoExecute(requestObj[key], r, dataTree[key][i], Object.assign({
                            nestedPage: rootArgs == null ? void 0 : rootArgs.nestedPage,
                            limit: rootArgs == null ? void 0 : rootArgs.nestedLimit
                        }, (rootArgs == null ? void 0 : (_rootArgs_nested1 = rootArgs.nested) == null ? void 0 : _rootArgs_nested1[key]) || {})));
                    }
                } else if (res1) {
                    var _rootArgs_nested2;
                    // Handle single objects
                    res[key] = await nocoExecute(requestObj[key], res1, dataTree[key], Object.assign({
                        nestedPage: rootArgs == null ? void 0 : rootArgs.nestedPage,
                        limit: rootArgs == null ? void 0 : rootArgs.nestedLimit
                    }, (rootArgs == null ? void 0 : (_rootArgs_nested2 = rootArgs.nested) == null ? void 0 : _rootArgs_nested2[key]) || {}));
                    dataTree[key] = res[key];
                } else {
                    res[key] = res1;
                }
            }
        }
        if (Object.prototype.hasOwnProperty.call(res, key)) {
            out[key] = await res[key];
        }
    }
    return out; // Return the final resolved output
};
